import { render, staticRenderFns } from "./SSOLogout.vue?vue&type=template&id=3c803f00"
import script from "./SSOLogout.vue?vue&type=script&lang=js"
export * from "./SSOLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports